import encodeAfacodes from 'modules/CitizenPortal/services/calls/geo/encodeAfacodes'
import { getPolygonCenter } from '../getPolygonCenter'
import { createAFACodePinLayer } from '../createAFACodePinLayer'
import { moveMapView } from '../moveMapView'
import { INSTITUTION_SLUG } from 'constants/system'

export async function AFACodeEncoded({
  lat,
  lon,
  mapInstance,
  view,
  _getMarkingData,
  openDrawer,
}: {
  mapInstance: any
  lat: string
  lon: string
  view: any
  _getMarkingData: any
  openDrawer: any
}) {
  const map = mapInstance.current
  if (!map) return
  try {
    const res = await encodeAfacodes({
      data: { lat: lat, lng: lon, u: INSTITUTION_SLUG == 'mocambique' ? '2' : '4' },
    })
    const { area, side } = res.body.afacode.properties
    const logistic_id = res.body.afacode.id
    const geometry = res.body.afacode.geometry

    const { centerLat, centerLon } = getPolygonCenter(geometry)

    // Cria nova layer com os pins
    const newPin = {
      id: logistic_id,
      lat: centerLat,
      lon: centerLon,
      type: 'afacode',
      data: {
        area: area,
        side: side,
        logistic_id: logistic_id,
        geometry: geometry,
        lat: centerLat,
        lon: centerLon,
      },
    }
    const afaLayer = createAFACodePinLayer({ pin: newPin })
    if (afaLayer) {
      afaLayer.setZIndex(999)
      map.addLayer(afaLayer)
    }
    //MOVIMENTANDO O MAPA PARA O PONTO CLICADO
    moveMapView({ map, view, centerLat, centerLon })

    //ABRINDO ENTIDADE AFACODE NO DRAWER
    openDrawer({ type: 'afacode', data: { area: area, side: side, logistic_id: logistic_id, geometry: geometry } })

    //CHAMANDO FUNÇÃO DE PREENCHER ENDEREÇO
    _getMarkingData({ centerLat, centerLon })
  } catch (err) {
    console.error('Erro ao buscar polígono:', err)
  }
}
